<template>
  <chapter-form
    v-model="form"
    :max="course.ordered_chapter_ids.length"
    class="max-w-3xl bg-white"
    @submit="submit"
  >
    <div class="flex items-center justify-end border-t px-8 py-4">
      <loading-button
        :loading="form.processing"
        class="btn-teal ml-auto"
        type="submit"
      >
        Update Chapter
      </loading-button>
    </div>
  </chapter-form>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton.vue';
import ChapterForm from './Form.vue';
import omit from 'lodash/omit';
import axios from 'axios';

export default {
  components: {
    LoadingButton,
    ChapterForm,
  },
  props: {
    chapter: {
      type: Object,
      required: true,
    },
    course: {
      type: Object,
      required: true,
    },
  },
  emits: ['success'],
  data() {
    return {
      form: this.$inertia.form({
        chapter: {
          ...omit(this.chapter, 'id', 'subjects', 'ordered_subjects_ids'),
        },
        position:
          this.course.ordered_chapter_ids.findIndex(
            (elem) => elem == this.chapter.id,
          ) + 1,
      }),
    };
  },
  methods: {
    async submit() {
      try {
        await axios.put(this.$routes.chapter(this.chapter.id), {
          format: 'json',
          ...this.form,
        });
        this.form.reset('chapter');
        this.$emit('success');
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
